// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

import { ThemeProvider } from '@mui/material/styles'; // <-- Import
import { theme } from './theme'; // <-- Import our custom theme
import CssBaseline from '@mui/material/CssBaseline'; // <-- Import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      {/* Wrap the app with the ThemeProvider */}
      <ThemeProvider theme={theme}>
        {/* CssBaseline resets default browser styles for consistency */}
        <CssBaseline />
        <App />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);